import * as React from 'react';
import { useDataLoader, usePerformAction } from 'react-remote-data-hooks';
import api from '../../../api';
import { GeneralSettings, ITemplateKeyItem } from '../../../core';
import { useAppSettings } from '../../../core/hooks/useAppSettings';
import UpdateForm from '../../general-settings/tabs/general-settings/UpdateForm';

interface ITemplateSettingsProps {
  data?: GeneralSettings;
  reload?: () => void;
  onSelectTemplate: (key: string) => void;
}

const TemplateSettingsItems: React.FunctionComponent<ITemplateSettingsProps> = (
  props
) => {
  const [selectedKey, setSelectedKey] = React.useState<string>();

  const { data, error: updateError, loading, loaded } = useDataLoader(
    (): Promise<ITemplateKeyItem[]> => api.settings.getTemplateKeys()
  );

  const keyItems: ITemplateKeyItem[] = data;
  React.useEffect(() => {
    if (!selectedKey && keyItems?.length > 0) {
      setSelectedKey(keyItems[0].key);
      props.onSelectTemplate(keyItems[0].key);
    }
  }, [keyItems]);

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Template Management</h4>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Template
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {keyItems?.map((p) => {
                return (
                  <tr
                    onClick={() => {
                      setSelectedKey(p.key);
                      props.onSelectTemplate(p.key);
                    }}
                    className={`cursor-pointer ${
                      p.key === selectedKey
                        ? 'selected-key bg-lightblue font-weight-semibold'
                        : ''
                    }`}
                  >
                    <td>
                      <span
                        className={`py-1 d-inline-block font-normal ${
                          p.key === selectedKey
                            ? 'font-weight-semibold'
                            : 'font-weight-normal'
                        }`}
                      >
                        {p.name}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default TemplateSettingsItems;
